/** Anonymous case reference shown in practitioner-facing UI (e.g. P-047). */
export function formatParticipantReference(participantId) {
    return `P-${participantId.toString().padStart(3, "0")}`;
}
